import Header from "./components/Header";
import Home from "./pages/Home";
import Details from "./pages/Details";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Header />   

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/post/:id" element={<Details />} />

        {/* ✅ Added routes for navbar buttons */}
        <Route path="/notifications" element={<h2>Notifications Page</h2>} />
        <Route path="/bookmarks" element={<h2>Bookmarks Page</h2>} />
        <Route path="/profile" element={<h2>Profile Page</h2>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;